module.exports = __webpack_public_path__ + "img/mock.1e144660.svg";